module.exports = __webpack_public_path__ + "img/pro-m-slider3.49d63cb2.png";